import React, { Component } from 'react';
import Auth from '../../utils/auth';
import * as kyc from '../../services/kyc/kyc-service';
import * as Loader from '../../common/common';

export default class KycStatus extends Component {
  state = {
    kycStatus: '',
    statusDate: '',
    rejectionReason: '',
    message: ''
  }

  async getKycStatus() {
    Loader.showLoader();
    let { response, err } = await kyc.getKycStatus(Auth.get("userId"));
    Loader.hideLoader();
    if (err) {
    }
    else if (response && response.data.err) {
    }
    else {
      this.setState(
        {
          kycStatus: response.data.kycStatus,
          statusDate: response.data.statusDate,
          rejectionReason: response.data.rejectionReason,
        },
        () => this.buildMessage()
      );
    }
  }

  buildMessage() {
    let kycStatus = this.state.kycStatus;
    let statusDate = this.state.statusDate && this.state.statusDate.slice(0, 10);
    let message = '';

    switch (kycStatus) {
      case 'SUBMITTED':
        message = `Your KYC was SUBMITTED on ${statusDate} and is In Process`;
        break;
      case 'APPROVED':
        message = `Your KYC was APPROVED on ${statusDate}`;
        break;
      case 'REJECTED':
        message = `Your KYC was REJECTED on ${statusDate} \n Reason : ${this.state.rejectionReason} `;
        break;
      case 'CONFIRMED':
        message = `Your KYC was CONFIRMED on ${statusDate}`;
        break;
      case 'REOPENED':
        message = `Your KYC was enabled for modification on ${statusDate}`;
        break;
      default:
        message = 'Your KYC has not been Submitted';
    }

    let msg = message.split('\n').map((t, index) => <p key={index}>{t}</p>);
    this.setState({
      message: msg
    })
  }

  async componentDidMount() {
    this.getKycStatus();
  }

  render() {
    return (
      <React.Fragment>
        <div className="container">
          <div className="row">
            <div className="col-md-12 card  mt-5">
              <h3 className="text-center pt-3">KYC STATUS</h3> <hr />
              <div className=" pt-2 pb-2 pl-2">
                <div className="text-center">
                  {this.state.message[0]}
                  {this.state.message.length > 1 ? this.state.message[1] : null}
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    )
  }
}